import React, { ChangeEvent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CheckboxProps, Container, Grid, Icon } from "semantic-ui-react";
import { getUserDetails } from "../../actions/authActions";
import { USER_UPDATE_RESET } from "../../actions/constants/user";
import { deleteUser, updateUser } from "../../actions/userActions";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { Heading2 } from "../../components/value-cssmodules/TextComponent";
import { userDetailsSelector, userUpdateSelector } from "../../utils/selectors";
import UserForm from "../Register/UserForm";
import Spinner from "../../components/Spinner";
import ConfirmButtons from "../../components/ConfirmButtons";
import api from "../../utils/api";

const UserEdit = () => {
  const userDetails: any = useSelector((state: any) =>
    userDetailsSelector(state)
  );
  const { loading, error, success } = useSelector((state: any) =>
    userUpdateSelector(state)
  );
  const { user } = userDetails;

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    isAdmin: false,
  });
  const [isSuspended, setIsSuspended] = useState(false);
  const [suspendReason, setSuspendReason] = useState("");
  const [isBanned, setIsBanned] = useState(false);
  const [banReason, setBanReason] = useState("");

useEffect(() => {
  if (success) {
    dispatch({ type: USER_UPDATE_RESET });
    navigate("/admin/users");
    return;
  }

  if (id) {
    dispatch(getUserDetails(id));
  }
}, [dispatch, id, success, navigate]);

useEffect(() => {
  if (user) {
    setFormData({
      name: user.name,
      email: user.email,
      isAdmin: user.isAdmin,
    });

    setIsBanned(user.isBanned ?? false);
    setBanReason(user.banReason ?? "");
    setIsSuspended(user.isSuspended ?? false);
    setSuspendReason(user.suspendedReason ?? "");
  }
}, [user]);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCheckboxChange = (
    e: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) => {
    setFormData({ ...formData, isAdmin: data.checked || false });
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch(updateUser({ ...formData, _id: id }));

 /**
 * Update user ban/suspend status only if changed
 */
   if (isSuspended !== user.isSuspended) {
    if (isSuspended) {
      await api.put(`/users/${id}/suspend`, { reason: suspendReason });
    } else {
      await api.put(`/users/${id}/unsuspend`);
    }
  }

  if (isBanned !== user.isBanned) {
    if (isBanned) {
      await api.put(`/users/${id}/ban`, { reason: banReason });
    } else {
      await api.put(`/users/${id}/unban`);
    }
  }

  };

  const deleteHandler = () => {
    dispatch(deleteUser(id));
  };

  if (loading) {
    return <Spinner />;
  }
  console.log(error);
  return (
    <Container>
      <Grid padded="vertically" centered>
        <Grid.Row>
          <Grid.Column mobile={8} computer={4} style={{display: "flex", justifyContent: "center"}}>
            <Link to={"/admin/users"}>
              <PrimaryButton>
                <>
                  <Icon name="chevron left" />{" "}
                  <FormattedMessage id="site.goBack" />
                </>
              </PrimaryButton>
            </Link>
          </Grid.Column>
        </Grid.Row>{" "}
        <Grid.Row>
          <Grid.Column mobile={16} computer={12}>
            <Heading2>
              <FormattedMessage id="site.manageUser" />
            </Heading2>
            {/* {error && <Message warning>{error}</Message>} */}
            <UserForm
              data={formData}
              onChange={onChange}
              onSubmit={onSubmit}
              onCheckboxChange={onCheckboxChange}
              edit={true}
              isSuspended={isSuspended}
              suspendReason={suspendReason}
              onSuspendChange={(checked) => {
                setIsSuspended(checked);
                if (!checked) setSuspendReason("");
              }}
              onSuspendReasonChange={setSuspendReason}
              isBanned={isBanned}
              banReason={banReason}
              onBanChange={(checked) => {
                setIsBanned(checked);
                if (!checked) setBanReason("");
              }}
              onBanReasonChange={setBanReason}
            />

            <Heading2>
              <FormattedMessage id="site.removeUser" />
            </Heading2>
            <ConfirmButtons
              confirmHandler={deleteHandler}
              link={`users/${id}/edit`}
              confirmText={
                <FormattedMessage id={"admin.adminList.confirmUserDelete"} />
              }
              showEdit={false}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default UserEdit;
